module.exports = __webpack_public_path__ + "added.jpg?a35e3b37e19fb1dc5d3135dca3d07491";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendar-info/added.jpg
// module id = 493
// module chunks = 1